import styled from 'styled-components'

const PopupStyle = styled.div.attrs((props) => ({ className: props.className }))`
	--closeSizePos: var(--sp10x);
	--popupPadding: var(--sp9x);
	--popupContentMaxWidth: var(--sp201x);
	--popupContentMaxHeight: var(--sp110x);

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100vh;
	width: 100vw;
	z-index: 111;

	.popup-background {
		background-color: rgb(253 240 210 / 90%);
		pointer-events: all;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.popup-content-container {
		max-width: var(--popupContentMaxWidth);
		max-height: var(--popupContentMaxHeight);
		width: 100%;
		height: 100%;
		pointer-events: all;
		overflow: auto;
		margin: auto;

		&::-webkit-scrollbar {
			display: none;
		}

		.popup-content-wrap {
			width: 100%;
			height: 100%;
			background: var(--black) 0% 0% no-repeat padding-box;
			border-radius: 6px;
			opacity: 1;
			padding: var(--popupPadding);
			overflow-x: hidden;
			overflow-y: scroll;

			&::-webkit-scrollbar {
				display: none;
			}

			.close {
				cursor: pointer;
				position: absolute;
				top: var(--closeSizePos);
				right: var(--closeSizePos);
				width: var(--closeIconSize);
				height: var(--closeIconSize);
				color: var(--cream);
				i {
					font-size: var(--closeIconSize);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--closeSizePos: var(--sp9x);
		--popupPadding: var(--sp8x);
		--popupContentMaxWidth: var(--sp164x);
		--popupContentMaxHeight: var(--sp92x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--closeSizePos: var(--sp8x);
		--popupPadding: var(--sp7x);
		--popupContentMaxWidth: var(--sp152x);
		--popupContentMaxHeight: var(--sp84x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--closeSizePos: var(--sp6x);
		--popupPadding: var(--sp6x);
		--popupContentMaxWidth: var(--sp125x);
		--popupContentMaxHeight: var(--sp70x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--closeSizePos: var(--sp6x);
		--popupPadding: var(--sp6x);
		--popupContentMaxWidth: var(--sp93x);
		--popupContentMaxHeight: var(--sp80x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--closeSizePos: var(--sp4x);
		--popupPadding: var(--sp4x) var(--sp2x);
		--popupContentMaxWidth: var(--sp46x);
		--popupContentMaxHeight: var(--sp72x);
	}
`
export default PopupStyle
